// extracted by mini-css-extract-plugin
export default {"chartCategoryContainer":"style_chartCategoryContainer__ss6p5","chartCategoryTitle":"style_chartCategoryTitle__+-7ML"};